import type { FaireProductEntity } from "../../entity_types/product";

export const p_ghvunnspwa: FaireProductEntity = {
  token: "p_ghvunnspwa",
  type: "product",
  name: "Tic-Tac-Toe Beans",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/bea8f6db39ffe15babe90cf1f0c8831fa95000a2cb6caa66aaad377b30b3c9be.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.48,
  description: "A miniature version of the classic game of tic-tac-toe complete with a 5 1/2 x 5 1/2 inch board and 10 playing pieces now with a cat lover’s twist! Includes a 5 1/2 x 5 1/2 inch foldable magnetic board and 10 wooden X & O toe bean game pieces. Mini Book Included: Includes a humorous and instructional mini book with full-color illustrations. Portable: Small size makes for feline fun anytime, anywhere. Purrfect Gift: Makes a great gag gift or self-purchase for cat lovers.",
  tags: [],
  msrpDollars: 12.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:55.087Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
